import urlFriendly from './url-friendly';

export default function getSections(section) {
    const parent = section.parent;

    if (parent) {
        return {
            section: urlFriendly(parent.title),
            subSection: urlFriendly(section.title),
        };
    }

    return {
        section: urlFriendly(section.title),
        subSection: '',
    };
}



/** WEBPACK FOOTER **
 ** ./src/utils/get-sections.js
 **/